import { render, staticRenderFns } from "./text-input.vue?vue&type=template&id=3ab64c11&"
import script from "./text-input.ts?vue&type=script&lang=ts&"
export * from "./text-input.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports